import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form-empty"
}
const _hoisted_3 = { class: "action" }
const _hoisted_4 = { class: "action-title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "infos" }
const _hoisted_10 = { class: "line" }
const _hoisted_11 = { class: "line" }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = { class: "line" }
const _hoisted_14 = { class: "line" }
const _hoisted_15 = { class: "actions" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import {
  analysisEquipmentList,
  analysisEquipmentCreate,
  analysisEquipmentDelete,
} from "@/common/api/rest/analysis/equipment";

import { equipmentPatch } from "@/common/api/rest/equipment";

import type { AnalysisType } from "@/common/types/analysis";
import type {
  EquipmentType,
  EquipmentListType,
  EquipmentPayloadType,
} from "@/common/types/equipment";

import {
  equipmentForm,
  equipmentDetailsForm,
  searchEquipment,
} from "@/components";
import {
  svgIcon,
  baseInput,
  baseModal,
  baseConfirm,
  baseTooltip,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'equipment',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const equipments = ref<EquipmentType[]>([]);
const selected = ref<any>(null);

const payload = ref<EquipmentPayloadType | null>(null);
const inputSearch = ref("");

const showModalAdd = ref(false);
const showDelConfirm = ref(false);

const equipmentsIds = computed(
  () => equipments.value?.map((item) => item.equipment_id) || [],
);

function listEquipments() {
  if (!props.data) return;

  analysisEquipmentList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    page: 0,
    limit: 100,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        equipments.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function add() {
  showModalAdd.value = true;
}

function addSelect(data: any[]) {
  selected.value = data[0];
}

function addCancel() {
  selected.value = null;
  showModalAdd.value = false;
}

function addConfirm() {
  if (!props.data || !selected.value) return;

  analysisEquipmentCreate(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    equipment_id: selected.value.equipment_id,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        listEquipments();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });

  inputSearch.value = "";
  addCancel();
}

function del(data: EquipmentType) {
  selected.value = data;
  showDelConfirm.value = true;
}

function delCancel() {
  selected.value = null;
  showDelConfirm.value = false;
}

function delConfirm() {
  if (!props.data || !selected.value) return;

  analysisEquipmentDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        listEquipments();
        delCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(() => {
  listEquipments();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (equipments.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("analysis.texts.empty_equipment")), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(equipments.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "item"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)("common.labels.equipment")) + " " + _toDisplayString(index + 1), 1),
                (__props.isEdit)
                  ? (_openBlock(), _createBlock(_unref(baseTooltip), {
                      key: 0,
                      position: "relative"
                    }, {
                      trigger: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-none btn-sm remove",
                          onClick: ($event: any) => (del(item))
                        }, [
                          _createVNode(_unref(svgIcon), {
                            icon: "trash",
                            size: "1.75rem"
                          })
                        ], 8, _hoisted_5)
                      ]),
                      tooltip: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("common.labels.delete")), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (item.avatar)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: item.avatar.small
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.code")) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(item?.code), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.brand")) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(item?.brand), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.name")) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(item?.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.model")) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(item?.model), 1)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", null, _toDisplayString(_unref(t)("common.labels.serial_number")) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(item?.serial_number), 1)
                  ])
                ])
              ])
            ]))
          }), 128)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "btn btn-md btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
        }, _toDisplayString(_unref(t)("common.labels.add").toUpperCase()), 1)
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.equipment'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchEquipment), {
          "account-id": __props.data?.account_id,
          ids: equipmentsIds.value,
          unic: true,
          onUpdateData: addSelect
        }, null, 8, ["account-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.equipment'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: payload.value?.name,
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})